module.exports = __webpack_public_path__ + "img/组 1.25d4816a.png";